import { config } from "../config";
import "./Footer.css";

export function Footer() {
  return (
    <footer className="footer">
      <p>© 2023 The Internet’s Most Recognizable Meme. ALL RIGHTS RESERVED!</p>
      <p>
        VERIFIED SMART CONTRACT ADDRESS:{" "}
        <a
          href={`https://etherscan.io/address/${config.tokenContractAddress}`}
          target="_blank"
          rel="noreferrer"
        >
          {config.tokenContractAddress}
        </a>
      </p>
    </footer>
  );
}
